import React, { Fragment } from "react";
import TwoCol from "../../containers/twoCol";
import FlexText from "../../flexText";
import TitleBar from "../../titleBar";
import Button from "../../button";
function makeArrowButtons(linkField, item) {
  console.log("LINK FIELD->", linkField);

  return linkField.map((button, index) => (
    <Fragment key={index}>
      <Button
        url={button.url}
        id={"item" + item + "_button" + index}
        styles={{ textTransform: "uppercase", fontFamily: "Oswald" }}
        className="GreenButtonWithArrow"
      >
        {button.title}
      </Button>
    </Fragment>
  ));
}
const TitleWithDescription = ({
  Styles,
  row,
  title,
  linkColor,
  padding,
  colHeight,
  bgColor,
  ImageBG,
  bgImage,
  left,
  field_boolean_2,
  titleStyles,
  attributes,
  item,
}) => (
  <TwoCol
    className={"twd " + linkColor}
    styles={{
      lineBreak: "word",
      height: colHeight,
      padding: padding,
      backgroundColor: bgColor,
      ...ImageBG,
    }}
  >
    {left && field_boolean_2 !== "0" ? (
      <TitleBar
        max="19"
        min="16"
        container="Left"
        tag="h2"
        color={titleStyles.field_color_1}
        bgc={titleStyles.field_bgcolor_1}
        fontFamily={titleStyles.field_font_1.name}
        divStyle={{
          ...Styles.divStyle,
          top: "36px",
          left: "24px",
        }}
      >
        {title}
      </TitleBar>
    ) : null}
    <FlexText
      tag="h3"
      max="32"
      min="28"
      color={attributes.field_heading_color_font[0].field_color_1}
      styles={{
        textTransform: "uppercase",
        fontWeight: "normal",
        fontFamily: "Oswald, sans-serif",
        textAlign: "left",

        textDecoration: "none",
        marginTop: "-5px",
        color: attributes.field_heading_color_font[0].field_color_1,
      }}
    >
      {row.field_text_1}
    </FlexText>
    <FlexText
      max="16"
      min="13"
      tag="p"
      color={attributes.field_text_color_font[0].field_color_1}
      styles={{
        fontFamily: "Roboto",
        textAlign: "left",

        fontWeight: "400",
        textTransform: "none",
      }}
    >
      {row.field_longtext_1}
    </FlexText>
    {typeof row.field_links_1 !== "undefined" ? (
      Array.isArray(row.field_links_1) ? (
        makeArrowButtons(row.field_links_1, item)
      ) : (
        <Button
          id={"item" + item + "_button0"}
          url={row.field_links_1.url}
          linkStyle={linkColor}
          className="GreenButtonWithArrow"
        >
          {row.field_links_1.title}
        </Button>
      )
    ) : (
      <Fragment />
    )}
  </TwoCol>
);

export default TitleWithDescription;
